export default __webpack_public_path__ + "static/media/edit.2b90ec7f.svg";